export function calculatePointsFromPrice(price: number) {
    const POINT_CONVERSION_RATE = 0.0025;
    return Math.ceil(price / POINT_CONVERSION_RATE);
}
